import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import {withGreen800, withNeutral800} from '@/hocs/withColors';
import {withBoldWeight, withHomeSubP} from '@/hocs/withFontType';
import {withMarginTopDoubleLg} from '@/hocs/withSpacing';
import Link from '@/links';
import ScrollingHandler from '@/scrollinghandler';
import {SectionPadding} from '@/section';
import {H1, P, PNoMargin} from '@/typography';
import {GridItem, GridLayout} from '@/ui/grid/grid-layout';
import PictureWrapper from '@/ui/images-wrapper';
import partnerStyles from 'pages/partnership-program/partners.module.scss';

const prepareLink = ScrollingHandler.prepareOnClick;

const H1Green800 = withGreen800(H1);
const SubPNeutral800 = withNeutral800(withHomeSubP(P));
const MarginTopDoubleLg = withMarginTopDoubleLg('div');
const BoldSpan = withBoldWeight('span');

const imgPath = '/static/images/partnership-program/main-page/hero-section/';

const responsiveImages = {
  desktopImageUrl: 'hero-illustration-partnerships-desktop',
  mobileImageUrl: 'hero-illustration-partnerships-mobile'
};

const partnerBenefits = [
  {
    copy: (
      <>
        Get discovered by hiring teams searching for <BoldSpan>trusted tools</BoldSpan> that
        <BoldSpan> integrate with Workable</BoldSpan>
      </>
    )
  },
  {
    copy: (
      <>
        <BoldSpan>Showcase your brand</BoldSpan> alongside industry-leading solutions
      </>
    )
  },
  {
    copy: (
      <>
        Drive <BoldSpan>more traffic</BoldSpan> and <BoldSpan>qualified leads</BoldSpan> to your
        platform
      </>
    )
  }
];

const PartnersHeroSection = () => (
  <SectionPadding>
    <Container variant="section-padding-below-nav">
      <Grid fluid>
        <Row center="xs">
          <Col xs={12} lg={8}>
            <H1Green800>Partner with Workable</H1Green800>
            <SubPNeutral800>
              Workable is the world’s leading recruitment and HR platform for growing businesses.
              Join our partner ecosystem to grow your customer-base, tap into new networks and help
              your clients find and hire the best talent.
            </SubPNeutral800>
            <Link
              href="/partnership-program#find-the-right-partnership"
              onClick={prepareLink('/partnership-program#find-the-right-partnership')}
              variant="primary">
              Explore partner program
            </Link>
          </Col>
        </Row>
        <MarginTopDoubleLg>
          <Row>
            <Col xs={12} lg={12}>
              <GridLayout lgCol={1} Col={3} autoRows>
                <GridItem lgCol={1} Col={3} lgRow={1} Row={2}>
                  <PictureWrapper
                    imgPath={imgPath}
                    responsiveImages={responsiveImages}
                    altImage="About Workable Partners"
                    className={partnerStyles['bg-img']}
                    width={1208}
                    height={660}
                    fetchpriority="high"
                    loading="eager"
                  />
                </GridItem>
                {partnerBenefits.map((item, index) => (
                  <GridItem Col={1} Row={1} key={index}>
                    <div className={partnerStyles['box-grid-center-content']}>
                      <PNoMargin>{item.copy}</PNoMargin>
                    </div>
                  </GridItem>
                ))}
              </GridLayout>
            </Col>
          </Row>
        </MarginTopDoubleLg>
      </Grid>
    </Container>
  </SectionPadding>
);

export default PartnersHeroSection;
